<div class="u-flex-full">
  <label>{{value?.id}} </label>
  <button class="close" *ngIf="value" mat-button type="button" matSuffix mat-icon-button aria-label="Clear"
    (click)="clearExpense()">
    <mat-icon>close</mat-icon>
  </button>
</div>